<template>
    <div class="main-container">

        <h2 class="title"><a v-if="routeName == 'TUTOR_DETAIL_DASHBOARD'" @click="backRoute()"><i class="material-icons">arrow_back</i></a><template v-if="tutorResumeReady"><span>{{tutorResume.firstname}} {{tutorResume.lastname}}</span></template></h2>
        
        <Filters v-show="!jobsView"
            @change="(data) => changeFilters(data)"
            :idFilialesReq="tutorId"
        />

        <div class="toggle-view__container">
            <button :class="{'active': !jobsView}" @click.stop="jobsView = false">
                <i class="material-icons">dashboard</i>
                <span>Dashboard</span> 
            </button>
            <button :class="{'active': jobsView}" @click.stop="jobsView = true;loadJobSearches();">
                <i class="material-icons">work</i>
                <span>Búsquedas laborales</span> 
            </button>
        </div>

        <div v-if="!jobsView && tutorResumeReady" class="dashboard">

            <div class="dashboard__row1" v-if="!levelSelected || levelSelected == 5">
                <ExternalChart :title="'Situación laboral'" :idData="{name:'tutorId',id:tutorResume.id}" :spName="tutorResume.spName" :graphicDataKey="'workSituation'" :graphicData="tutorResume.workSituation.items" :graphicColors="graphicWorkColors"/>
                <ExternalChart :title="'Situación respecto de Ruky'" :idData="{name:'tutorId',id:tutorResume.id}" :spName="tutorResume.spName" :graphicDataKey="'rukySituation'" :graphicData="tutorResume.rukySituation.items" :graphicColors="graphicRukyColors"/>
                <div class="dashboard__jobSearchs">
                    <div v-for="(item,index) in tutorResume.jobSearchData" :key="index" class="dashboard__jobSearchs__item" 
                    @click.stop="navigateParentWindow(tutorResume.spName,tutorResume.id,item.key)">
                        <span>{{$t(`forge_dashboard.${item.key}`)}}</span><span>{{item.value}}</span>
                    </div>
                </div>
            </div>

            <div class="dashboard__row2">
                <ExternalChart :title="'Ingreso a la plataforma'" :idData="{name:'tutorId',id:tutorResume.id}" :spName="tutorResume.spName" :graphicDataKey="'loginStatus'" :graphicData="tutorResume.loginStatus.items" :graphicColors="graphicLoginColors"/>
                <ExternalChart v-if="!levelSelected || levelSelected == 5" :title="'Actividades para postular'" :idData="{name:'tutorId',id:tutorResume.id}" :spName="tutorResume.spName" :graphicDataKey="'tripStatus'" :graphicData="tutorResume.tripStatus.items" :graphicColors="graphicTripColors"/>
                <!-- <ExternalChart :title="'Completitud de perfiles'" @openModal="(type)=>openModalJovenes(type)" :graphicData="tutorResume.profileCompletition.items" :graphicColors="graphicProfileColors"/> -->
                <ExternalChart :title="'Completitud de perfiles'" :idData="{name:'tutorId',id:tutorResume.id}" :spName="tutorResume.spName" :graphicDataKey="'profileCompletition'" :graphicData="tutorResume.profileCompletition.items" :graphicColors="graphicProfileColors"/>
            </div>

        </div>

        <div v-else class="jobs">

            <!-- Modal Job Detail -->
            <div class="modal__overlay" v-if="modalJobDetail" @click.stop="modalJobDetail=false;jobSearchDetail=null">
                <div class="modal" v-if="modalJobDetail" @click.stop="''">
                    <div class="modal__header">
                        <h2>Detalle de la búsqueda</h2>
                        <div class="modal__close"><i class="material-icons" @click.stop="modalJobDetail=false;jobSearchDetail=null">close</i></div>
                    </div>
                    <div class="modal__grid">
                        <div class="modal__column">
                            <div class="modal__group">
                                <h3>Nombre de la búsqueda</h3>
                                <h4>{{jobSearchDetail.title}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Fecha de cierre</h3>
                                <h4>{{formatDate(jobSearchDetail.closeDate)}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Descripción</h3>
                                <p>{{jobSearchDetail.desciption}}</p>
                            </div>
                            <div class="modal__group">
                                <h3>Posición</h3>
                                <h4>{{jobSearchDetail.position}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Seniority</h3>
                                <h4>{{jobSearchDetail.seniority}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Tipo de contrato</h3>
                                <h4>{{jobSearchDetail.typeOfContract}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Modalidad</h3>
                                <h4 v-if="jobSearchDetail.workPlace == 0">Presencial</h4>
                                <h4 v-if="jobSearchDetail.workPlace == 1">Remoto</h4>
                                <h4 v-if="jobSearchDetail.workPlace == 2">Híbrido</h4>
                            </div>
                        </div>
                        <div class="modal__column">
                            <div class="modal__group">
                                <h3>Género</h3>
                                <h4>
                                    {{jobSearchDetail.gender}}
                                </h4>
                            </div>
                            <div class="modal__group">
                                <h3>Nivel educativo</h3>
                                <h4>
                                    {{ $t(`jobsearch.create.educationLevels.${jobSearchDetail.minimumEducationLevel}`)}}
                                </h4>
                            </div>
                            <div class="modal__group">
                                <h3>Habilidades requeridas</h3>
                                <h4>
                                    {{jobSearchDetail.skillsRequired}}
                                    <!-- <template v-for="(skill,index) in jobSearchDetail.skillsRequired" :key="index">{{skill}}. </template> -->
                                </h4>
                            </div>
                            <div class="modal__group">
                                <h3>Otras habilidades buscadas</h3>
                                <h4>
                                    {{jobSearchDetail.optionalSkills}}
                                </h4>
                            </div>
                            <div class="modal__group">
                                <h3>Beneficios</h3>
                                <h4>
                                    {{jobSearchDetail.benefits}}
                                    <!-- <template v-for="(bennefit,index) in jobSearchDetail.bennefits" :key="index">{{bennefit}}. </template> -->
                                </h4>
                            </div>
                            <div class="modal__group">
                                <h3>Otros beneficios</h3>
                                <p>{{jobSearchDetail.otherBeneffits !='' ? jobSearchDetail.otherBeneffits : '-'}}</p>
                            </div>
                        </div>
                        <div class="modal__column">
                            <div class="modal__group">
                                <h3>Empresa</h3>
                                <h4>{{jobSearchDetail.organizationName}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>País</h3>
                                <h4>{{jobSearchDetail.country}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Provincia</h3>
                                <h4>{{jobSearchDetail.state}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Ciudad</h3>
                                <h4>{{jobSearchDetail.city}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Dirección</h3>
                                <h4>{{jobSearchDetail.jobAddress}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Horarios</h3>
                                <h4>{{jobSearchDetail.jobSchedule}}</h4>
                            </div>
                            <div class="modal__group">
                                <h3>Salario aproximado</h3>
                                <h4>{{jobSearchDetail.salaryAround == 0 ? 'No especificado' : `$${jobSearchDetail.salaryAround} ${jobSearchDetail.currencyCode}`}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="modal__buttons">
                        <button @click.stop="copyClipboard(jobSearchDetail.link)">Copiar link <i class="material-icons">content_copy</i></button>
                        <button @click.stop="getExcelReport()">Descargar postulantes<i class="material-icons">file_download</i></button>
                    </div>
                </div>
            </div>

            <!-- Nav filters 
            <div class="search-nav">
                <div class="search-nav__search-field">
                    <span><i class="material-icons">search</i></span>
                    <input type="search" v-model="modelFilters.filter" placeholder="Buscar por título" @keydown.enter="applyFilters()">
                </div>
                <div class="search-nav__filter">
                    <button @click.stop="applyFilters();">
                        <span>Buscar</span>
                        <i class="material-icons">search</i> 
                    </button>
                </div>
            </div>-->

            <div v-if="jobsView" class="new-search">
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <span>{{$t("jobsearch.tableheader.title")}}</span> 
                                </th>
                                <th>
                                    <span>Empresa</span>
                                </th>
                                <th>
                                    <span>Provincia/Estado</span> 
                                </th>
                                <th>
                                    <span>Dirección</span> 
                                </th>               
                                <th>
                                    <span>{{$t("jobsearch.tableheader.endDate")}}</span>                
                                </th> 
                                <th>
                                    <span>Habilidades requeridas</span> 
                                </th>
                                <th>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="jobSearchActivesReady && jobsView">
                                <template v-if="jobSearchActives.length == 0">
                                    <tr v-for="jsa in jobSearchActives" :key="jsa.id">
                                        <td colspan="6">No hay búsquedas laborales</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr v-for="jsa in jobSearchActives" :key="jsa.id">
                                    <td class="table-container__title">
                                        {{ jsa.title }}
                                    </td>
                                    <td>{{ jsa.organizationName }}</td>
                                    <td>{{ jsa.state }}</td>
                                    <td>{{ jsa.address }}, {{jsa.city}}</td>
                                    <td>{{ formatDate(jsa.closeDate) }}</td>
                                    <td class="table-container__skills">
                                        <span v-if="jsa.skillsRequired.length == 0">-</span>
                                        <template v-else>
                                            <span v-for="(skill,index) in jsa.skillsRequired" :key="index">{{skill}}</span>
                                        </template>
                                    </td>
                                    <td class="table-container__actions">
                                        <button class="table-container__actions__btn-detail" @click.stop="openJobSearchDetail(jsa.id)">
                                            <span>Ver detalle</span>
                                            <i class="material-icons">zoom_in</i>
                                        </button>
                                        <button class="table-container__actions__btn-copy-link" @click.stop="copyClipboard(jsa.link);">
                                            <span>Copiar link</span>
                                            <i class="material-icons">content_copy</i>
                                        </button>
                                    </td>
                                    </tr>
                                </template>
                            </template>
                            <template v-if="!jobSearchActivesReady && jobsView">
                                <tr v-for="index in 3" :key="index">
                                    <td><Skeletor width="100%" height="24"/></td>
                                    <td><Skeletor width="100%" height="24"/></td>
                                    <td><Skeletor width="100%" height="24"/></td>
                                    <td><Skeletor width="100%" height="24"/></td>
                                    <td><Skeletor width="100%" height="24"/></td>
                                    <td><Skeletor width="100%" height="24"/></td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        
        </div>
    </div>

    <div class="modal__overlay" v-if="modalJovenes" @click.stop="modalJovenes = false">
        <div class="modal-jovenes" @click.stop="''">
            <div class="modal-jovenes__header">
                <div class="modal-jovenes__tabs">
                    <button v-if="modalJovenesType=='complete' || modalJovenesType=='incomplete'" @click.stop="openModalJovenes('incomplete');" class="modal-jovenes__tabs__btn-incomplete" :class="{'active': modalJovenesType == 'incomplete'}">Perfil incompleto</button>
                    <button v-if="modalJovenesType=='complete' || modalJovenesType=='incomplete'" @click.stop="openModalJovenes('complete');" class="modal-jovenes__tabs__btn-complete" :class="{'active': modalJovenesType == 'complete'}">Perfil completo</button>
                    <button v-if="modalJovenesType=='applied' || modalJovenesType=='notApplied'" @click.stop="openModalJovenes('applied');" class="modal-jovenes__tabs__btn-applied" :class="{'active': modalJovenesType == 'applied'}">Postulados</button>
                    <button v-if="modalJovenesType=='applied' || modalJovenesType=='notApplied'" @click.stop="openModalJovenes('notApplied');" class="modal-jovenes__tabs__btn-not-applied" :class="{'active': modalJovenesType == 'notApplied'}">No postulados</button>
                </div>
                <div class="modal-jovenes__close"><i class="material-icons" @click.stop="modalJovenes = false">close</i></div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Apellido</th>
                        <th>Completitud del perfil</th>
                        <th class="th-skill"><img src="@/assets/arrow-green.svg" alt=""><span>Competencias destacadas</span></th>
                        <th class="th-skill"><img src="@/assets/arrow-orange.svg" alt=""><span>Competencias a trabajar</span></th>
                    </tr>
                </thead>
                <tbody v-if="jovenesListReady">
                    <tr v-for="joven in jovenesList" :key="joven.id">
                        <td>{{joven.firstName}}</td>
                        <td>{{joven.lastName}}</td>
                        <td>{{joven.activity.completitionPercentaje}}%</td>
                        <td class="modal-jovenes__td-skills">
                            <span v-for="(skill,index) in joven.aptitudes.best" :key="index">{{skill}}</span>
                        </td>
                        <td class="modal-jovenes__td-skills">
                            <span v-for="(skill,index) in joven.aptitudes.worst" :key="index">{{skill}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { computed, onMounted, ref } from 'vue';
import moment from 'moment';
import { useI18n } from 'vue-i18n';
import { Skeletor } from 'vue-skeletor';
import ExternalChart from '@/components/External/Chart.vue';
import Filters from './Filters.vue';

export default {
    components:{
        Skeletor,
        ExternalChart,
        Filters
    },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const jobSearchActives = ref([]);
    const { t } = useI18n();
    const jobSearchActivesReady = ref(false);
    const modalJobDetail = ref(false);
    const jobSearchDetail = ref();
    const jobsView = ref(false);
    const tutorResume = ref();
    const tutorResumeReady = ref(false);
    const modalJovenes = ref(false);
    const modalJovenesType = ref('');
    const jovenesList = ref();
    const jovenesListReady = ref(false);
    const userData = computed(() => store.getters.externalData_userData);
    const tutorId = ref(0);
    const routeName = ref(route.name);
    const activeJobSearchId = ref(null);

    if(route.name == 'TUTOR_DASHBOARD')
    {
        tutorId.value = userData.value.id;
    }
    else
    {
        tutorId.value = route.params.id;
    }


    const graphicWorkColors = {
        NO_WORK: 'red',
        OWN_WORK: 'lightred',
        FORMAL: 'green',
        INFORMAL: 'yellow'
    }
    const graphicRukyColors = {
        NO_POSTULABLE_NO_INVITADO_RUKY: 'red',
        INVITADO_RUKY: 'green',
    }
    const graphicLoginColors = {
        NO_AFTER30: 'green', //Ingresaron hace menos de 30 dias
        NO_BEFORE30: 'yellow',
        NO_LOGIN: 'red'
    }
    const graphicTripColors = {
        TRIP_COMPLETED: 'green',
        TRIP_PENDING: 'red'
    }
    const graphicProfileColors = {
        COMPLETED: 'green',
        LESS_30: 'red',
        BETWEEN_30AND49: 'yellow',
        BETWEEN_50AND79: 'lightred',
        BETWEEN_80AND99: 'lightgreen'
    }

    
    const copyClipboard = (textCopy) => {
        const el = document.createElement('textarea');
        el.value = textCopy;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        store.dispatch('notifications_create', { text: 'Link copiado' });
    }

    async function getExcelReport() {
      const params = {
        searchId: activeJobSearchId.value,
        tutorId: tutorId.value,
        fileName: "Postulantes_" + jobSearchDetail.value.title
      }
      await store.dispatch('forgeDash_jobSearch_getExcelReport', params);
    }

    function backRoute () {
      if (window.history.length > 2) {
        router.go(-1)
      }
    }

    function navigateParentWindow(spName,id,value){
        let sp = {
            spName : spName,
            spData : { 
                tutorId: id,
                detailKey: 'jobSearchData',
                detailValue: value
            }
        } 
        parent.postMessage(JSON.stringify({
            type:"FullNavigate",
            data: {
                module:"Referenciales",
                view:"ShowDataView",
                params: {
                    params : [
                        {
                            dataType:"ExternalDashboardData",
                            originalData: JSON.stringify(sp)
                        }
                    ]
                },
                tabName: t(`forge_dashboard.${value}`)
            }
        }),"*");
    }

    const levelSelected = ref(null);
    const filterParams = ref('');
    function changeFilters(data){
        levelSelected.value = data.level;
        filterParams.value = data.queryParams;
        getTutorData()
    }

    async function getTutorData() {
        tutorResumeReady.value = false;
        try {    
          tutorResume.value = await store.dispatch('forgeDash_tutorResume',{ id: tutorId.value, queryParams: filterParams.value});
          //console.log(tutorResume.value)
          tutorResumeReady.value = true;
        } catch (e) {
          store.dispatch('notifications_create', { text: t(`notifications.generic`) });
        }        
    }


    onMounted(() => {
        getTutorData();
    });

    async function loadJobSearches(){
        try {
            jobSearchActives.value = await store.dispatch('forgeDash_jobSearches',{ id: tutorId.value, queryParams: filterParams.value});
            jobSearchActivesReady.value = true;            
        } catch (error) {
            store.dispatch('notifications_create', { text: t(`notifications.generic`) });
        }
    }

    async function openJobSearchDetail(jobSearchID) {
        try {
            activeJobSearchId.value = jobSearchID;
            jobSearchDetail.value = await store.dispatch('forgeDash_jobSearch',jobSearchID);
            console.log(jobSearchDetail);
            modalJobDetail.value = true;
        } catch (error) {
            store.dispatch('notifications_create', { text: t(`notifications.generic`) });
        }
    }

    function formatDate(dateTime) {
        return moment(dateTime).isValid() ? moment(dateTime).format("DD/MM/YYYY") : "";
    }

    async function openModalJovenes(type){
        jovenesListReady.value = false;
        modalJovenes.value = true;
        try {
            if(type == 'COMPLETED' || type == 'complete'){
                modalJovenesType.value = 'complete';
                jovenesList.value = await store.dispatch('forgeDash_profileCompleted',tutorId.value);
                jovenesListReady.value = true;
                return;
            }
            else if(type == 'incomplete' || type == 'LESS_30' || type == 'BETWEEN_30AND49' || type == 'BETWEEN_50AND79' || type == 'BETWEEN_80AND99'){
                modalJovenesType.value = 'incomplete';
                jovenesList.value = await store.dispatch('forgeDash_profileNotCompleted',tutorId.value);
                jovenesListReady.value = true;
                return;
            }
            else if(type == 'applied'){
                modalJovenesType.value = 'applied';
                jovenesList.value = await store.dispatch('forgeDash_userapplied',tutorId.value);
                jovenesListReady.value = true;
                return;
            }
            else if(type == 'notApplied'){
                modalJovenesType.value = 'notApplied';
                jovenesList.value = await store.dispatch('forgeDash_userNotApplied',tutorId.value);
                jovenesListReady.value = true;
                return;
            }
        }    
        catch (error) {
            store.dispatch('notifications_create', { text: t(`notifications.generic`) });
        }
    }
    
    return {
        jobSearchActives,
        jobSearchActivesReady,
        loadJobSearches,
        formatDate,
        jobSearchDetail,
        modalJobDetail,
        openJobSearchDetail,
        jobsView,
        modalJovenes,
        modalJovenesType,
        jovenesList,
        jovenesListReady,
        openModalJovenes,
        tutorResume,
        tutorResumeReady,
        copyClipboard,
        backRoute,
        routeName,
        graphicWorkColors,
        graphicRukyColors,
        graphicLoginColors,
        graphicTripColors,
        graphicProfileColors,
        getExcelReport,
        navigateParentWindow,
        changeFilters,
        levelSelected,
        tutorId
    }
  }

}
</script>

<style lang="scss" scoped>

    *{
        box-sizing: border-box;
    }

    .main-container {
        box-sizing: border-box;
        width: calc(100% - 32px);
        margin: $margin-base;
        padding: $margin-mega;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: $margin-base;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
        border-radius: $margin-base;
    }

    .title {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        gap: 16px;
        span{
            font-weight: 600;
            font-size: 26px;
            line-height: 40px;
            color: #231F20;
        }
        a{
            line-height: 30px;

            i{
                font-size: 36px;
            }
        }
    }

    .modal {
        background: #FFFFFF;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
        border-radius: 12px;
        max-width: 960px;
        padding: $margin-mega;
        width: 100%;

        &__header {
            align-items: center;
            display: flex;
            justify-content: space-between;
            margin-bottom: 24px;
            position: relative;

            h2 {
                @include font-settings(giga, base);
                color: #E87B1B;
                font-weight: 700;
                margin: 0;
            }

            i {
                position: relative;
                right: 0;
                top: 4px;
            }
        }

        &__grid {
            display: grid;
            gap: 40px;
            grid-template-columns: repeat(3, 1fr);
        }

        &__column {
            display: flex;
            gap: 16px;
            flex-direction: column;
        }

        &__group {
            text-align: left;

            h3 {
                @include font-settings(milli, mega);
                color: #231F20;
                font-weight: 600;
                margin: 0;
                padding: 0;
            }

            h4 {
                @include font-settings(base, mega);
                color: #231F20;
                font-weight: 700;
                margin: 0;
                padding: 0;
            }

            p {
                @include font-settings(milli, mega);
                color: #231F20;
                font-weight: 400;
                text-align: left;
                margin: 0;
            }
        }

        &__buttons {
            justify-content: flex-end;

            button {
                background: #E87B1B;
                border-radius: 50px;
                color: white;
                padding: 8px 24px;
                text-transform: initial;
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 16px;
                margin-left: 12px;
                margin-top: 8px;

                i {
                    color: white;
                    font-weight: 500;
                }
            }
        }
    }


.toggle-view__container{
    display: flex;
    flex-flow: row nowrap;
    gap: 16px;
    button{
        padding: 12px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 8px;
        background-color: #DBDBDB;
        color: #231F20;
        span{
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 16px;
        }
    }
    .active{
        background-color: $orange !important;
        >* {
            color: #fff !important;
        }
    }
}

/* DASHBOARD */
.dashboard{
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 24px;
    &__row1, &__row2{
        display: flex;
        flex-flow: row nowrap;
        gap: 24px;
    }
    &__jobSearchs{
        width: 33.3%;
        height: fit-content;
        padding: 16px;
        display: flex;
        flex-flow: column nowrap;
        gap: 16px;
        border: 1px solid #C4C4C4;
        border-radius: 4px;
        &__item{
            height: fit-content;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            gap: 52px;
            cursor: pointer;
            span{
                font-weight: 600;
            }
        }
    }
}

/* FIN DASHBOARD */

.jobs{
    width: 98%;
}
.table-container{
    width: 100%;
    overflow-x: auto;
    th{
        text-align: center;
    }
    tr{
        grid-template-columns: repeat(8, minmax(180px, 1fr));
    }    
    &__title {
      text-align: left;
    }
    &__skills{
        display: flex;
        flex-flow: column nowrap;
        span{
            font-size: 16px;
            font-weight: 700;
            color: #7d7d7d;
        }
    }
    &__actions{
        position: relative;
        gap: 16px;
        button{
            flex-shrink: 0;
            width: 160px;
            height: 40px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            gap: 4px;
            border-radius: 50px;
        }
        &__btn-detail{
            border: 1px solid $orange;
            span{
                font-size: 14px;
                font-weight: bold;
                color: $orange;
            }
            i{
                color: $orange;
            }
        }
        &__btn-copy-link{
            background-color: $orange;
            span{
                font-size: 14px;
                font-weight: bold;
                color: #fff;
            }
            i{
                color: #fff;
            }
 
        }
    }
}

.search-nav{
  margin-bottom: 16px;
  width: 100%;
  margin-top: 32px;
  display: flex;
  flex-flow: row wrap-reverse;
  gap: 8px;
  &__search-field{
    width: 100%;
    max-width: 345px;
    display: flex;
    span{
      height: 40px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      color: #7d7d7d;
      border-color: #7D7D7D;
      border-style: solid;
      border-width: 1px 0 1px 1px;
      border-radius: 3px 0 0 3px;
    }
    input{
      width: 100%;
      height: 40px;
      border: none;
      border: 1px solid #7D7D7D;
      border-color: #7D7D7D;
      border-style: solid;
      border-width: 1px 1px 1px 0;
      border-radius: 0 3px 3px 0;
      &::placeholder {
        font-family: Open Sans;
        font-weight: bold;
        font-size: 16px;
        color: #7d7d7d;
      }
    }
  }
  &__filter{
    button{
      width: 137px;
      height: 40px;      
      padding: 0px 16px;      
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border: 1px solid $red;
      border-radius: 3px;
      span{
        font-family: Palanquin Dark;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 25px;
        color:$orange;
      }
      i{
        color:$orange;
      }
    }
  }
}

.modal-jovenes{
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: 100px;
    width: 98%;
    max-width: 1200px;
    overflow-x: auto;
    height: fit-content;
    max-height: 80vh;
    overflow-y: auto;
    padding: 16px;
    display: flex;
    flex-flow: column nowrap;
    background-color: #fff;
    border: 1px solid #04A190;
    border-radius: 16px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
    z-index: 500;
    &__header{
        display: flex;
        justify-content: space-between;
    }
    &__tabs{
        padding-bottom: 16px;
        display: flex;
        gap: 16px;
        button{
            padding: 12px 16px;
            border-radius: 16px;
            background-color: #DBDBDB;
            font-weight: bold;
            &.active{
                color: #fff;
            }
        }
        &__btn-incomplete.active,&__btn-not-applied.active{
            background-color: #E25523;
        }
        &__btn-complete.active,&__btn-applied.active{
            background-color: #00866E;
        }

    }
    &__close{
        i{
            cursor: pointer;
        }
    }
    table{
        width: 100%;
        th,td{
            text-align: center;
        }
        th{
            font-weight: normal;
        }
        .th-skill{
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            gap: 8px;
        }
        tr{
            padding: 4px 0;
            display: grid;
            grid-template-columns: repeat(5, minmax(180px, 1fr));
            border-bottom: 1px solid rgba(0, 0, 0, 0.25);
            &:last-child{
                border: none;
            }
        }
        thead tr{
            padding: 8px 0;
            border-bottom: 1px solid #7D7D7D !important;
        }
        td{
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            font-weight: bold;
            span{
                font-weight: bold;
            }
        }
    }
}
.modal__buttons{
    gap: 8px;
    padding-top: 20px;
}
</style>
<style>
.custom-container {
    background:#fff;
}
</style>